import notify from 'components/atoms/Notify'
import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
import { parseCookies } from 'nookies'
import qs from 'qs'
import i18n from '../../i18n'
import refreshToken from './refreshToken'

const baseUrl = process.env.REACT_APP_BASE_URL

const apiGet = async (url, params, showError = true, retryCount = 0) => {
  const { accessToken, workspaceID, role, impersonateToken, isImpersonated, impersonateRole, companyBranchFilterId, dashboardRole } = parseCookies()

  const config = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': i18n.language || 'en',
    },
  }

  if (!isEmpty(accessToken)) {
    config.headers = {
      Authorization: isImpersonated && impersonateToken ? impersonateToken : accessToken,
      workspaceID,
      ...config.headers,
    }
    if (role && !isImpersonated) {
      config.headers.role = role
    } else if (isImpersonated && impersonateRole) {
      config.headers.role = impersonateRole
    }
    if (dashboardRole && !isImpersonated) {
      config.headers['X-Dashboard-Role'] = dashboardRole
    }
  }

  const baseParams = params && isObject(params) ? { ...params } : {}
  const mergedParams =
    companyBranchFilterId && baseParams.branchId === undefined && baseParams.BranchId === undefined ? { ...baseParams, branchId: companyBranchFilterId } : baseParams

  const query = qs.stringify(mergedParams)

  const response = await fetch(`${baseUrl}/admin/${url}?${query}`, config)
  const responseData = await response.json()

  if (response.status === 403 && retryCount === 0 && !isImpersonated) {
    const refreshed = await refreshToken()
    if (refreshed) {
      return apiGet(url, params, showError, retryCount + 1)
    } else {
      if (showError) {
        notify.error(responseData.message || 'Session expired. Please login again.', null, responseData.err)
      }
      return responseData
    }
  }

  // if (response.status !== 200) throw new Error('Some error occurred')
  if (!responseData.success && showError) {
    notify.error(responseData.message, null, responseData.err)
  }
  return responseData
}

export default apiGet

export const crmApiGetLeads = params => apiGet('crm/leads', params)
export const crmApiGetLeadById = id => apiGet(`crm/leads/${id}`)

export const preBookingsApiGetList = params => apiGet('pre-bookings', params)
export const preBookingApiGetById = id => apiGet(`pre-bookings/${id}`)
export const preBookingsApiGetFunnel = params => apiGet('stats/pre-bookings/funnel', params)
export const preBookingsApiGetOverview = params => apiGet('stats/pre-bookings/overview', params)
